import React from "react"
import { Col, Row, Tabs, Tab } from "react-bootstrap"
import { TranslationsChangesOverview } from "./TranslationsChangesOverview"
import { TranslationsOverview } from "./TranslationsOverview"
import { Link } from "react-router-dom"

export const Translations = () => {
    return (
        <Row className="content-section">
            <Col>
                <Link to="/translations/add" className="mt-4 btn btn-primary">
                    New translation
                </Link>
                <Tabs defaultActiveKey="overview" id="translations-tabs" className="mb-3">
                    <Tab eventKey="overview" title="Overview">
                        <TranslationsOverview />
                    </Tab>
                    <Tab eventKey="changes" title="Changes">
                        <TranslationsChangesOverview />
                    </Tab>
                </Tabs>
            </Col>
        </Row>
    )
}
